import { useEffect } from 'react'
import { reaction } from 'mobx'
import { useStores } from 'stores/utils/hooks/useStores'
import { pushGTMEvent } from 'utils/tracking'
import { TrackEventData } from 'utils/tracking/tracking.interface'
import { useUrlParams } from 'stores/utils/hooks/useUrlParams'

/**
 * Registers a MobX reaction that fires a GTM event whenever
 * `common.dataProcessingConsent` changes. Cleans up on unmount.
 */
const useDataProcessingConsentTracking = () => {
  const { traversal } = useStores()
  const urlParams = useUrlParams()

  useEffect(() => {
    if (urlParams.context === 'resume') {
      /* on resume, intentionally force the consent field to false before tracking; do not remove this line of code */
      traversal.handlePathFormFieldChange('common.dataProcessingConsent', false)
    }
    return reaction(
      () => traversal.data.common.dataProcessingConsent,
      () => {
        const event: {
          'contact-data-processing-consent': number
        } & TrackEventData = {
          event: 'wsContactDataProcessingConsentCheck',
          'contact-data-processing-consent': Number(
            traversal.data.common.dataProcessingConsent
          )
        }
        pushGTMEvent(event)
      }
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export default useDataProcessingConsentTracking
